import { ref, Ref, watch } from 'vue';
import { useUserProfile } from 'Store';
import { useForm } from 'Helpers/form';
import { FormModelSubscribeNewsletter } from '../models/FormModelSubscribeNewsletter';
import { useFormValidationSubscribeNewsletter } from './useFormValidationSubscribeNewsletter';

export function useFormSubscribeNewsletter() {
  const formModel: Ref<FormModelSubscribeNewsletter> = ref(new FormModelSubscribeNewsletter());
  const formValidation = useFormValidationSubscribeNewsletter(formModel);
  const formOptions = {
    formModel,
    formValidation,
    scrollTopOnSuccess: false,
    messageSuccess: 'Subscribed',
    resetOnSuccess: true,
  };

  // Set watch to prefill email by user email
  const { profileData } = useUserProfile();
  watch(() => profileData.value.email, (email) => {
    formModel.value.setDefinedFieldsData({ email: email || '' });
  });

  const formHandler = useForm(formOptions);

  return {
    ...formHandler,
    formModel,
  };
}
